import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Icon } from 'antd';
import './header.less';
class Header extends PureComponent {
  componentDidMount() {}
  render() {
    const { menu, headHighlight } = this.props;
    const currentHeadHighlight = headHighlight[0] && headHighlight[0].value;
    return (
      <div className="header">
        <Row type="flex" justify="start">
          <Col>
            <h1>TANTUER CMS</h1>
          </Col>
          <Col>
            <Row type="flex" justify="start">
              {menu.map((item, index) => {
                return (
                  <Col key={item.key}>
                    <Link
                      to={item.url}
                      className={
                        item.value === currentHeadHighlight
                          ? 'nav-item active'
                          : 'nav-item'
                      }
                    >
                      {item.icon && <Icon type={item.icon} />}
                      <span>{item.title}</span>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ...state.menu
  };
}
export default connect(mapStateToProps)(Header);
